import { render, staticRenderFns } from "./InstanceEditGeneral.vue?vue&type=template&id=0725636c&scoped=true&"
import script from "./InstanceEditGeneral.vue?vue&type=script&lang=js&"
export * from "./InstanceEditGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0725636c",
  null
  
)

export default component.exports